<div
  class="ir-area ir-mask th-mask"
  [open]="!isOpen"
  id="myModal"
  [attr.data-keyboard]="true"
  [attr.data-backdrop]="false"
  (click)="closeOnOutsideClick($event)"
>
  <div
    class="ir-btn ir-position--tr th-btn-modal"
    [ngClass]="hasClassModal ? 'modal' : ''"
    *ngIf="closeButton"
    (click)="close()"
  >
    <i class="material-icons">close</i>
  </div>
  <div #child></div>
</div>
